const storagePrefix = 'art_';
export const AUTH_STATUS_EVENT = 'auth-status-changed';

const storage = {
  setToken: (token) => {
    window.localStorage.setItem(`${storagePrefix}token`, JSON.stringify(token));
  }, 
  getToken: () => {
    return JSON.parse(window.localStorage.getItem(`${storagePrefix}token`));
  },
  clearToken: () => {
    window.localStorage.removeItem(`${storagePrefix}token`);
  },

  setAuthStatus: (status) => {
    window.localStorage.setItem(
      `${storagePrefix}auth_status`,
      JSON.stringify(Boolean(status))
    );
    window.dispatchEvent(new Event(AUTH_STATUS_EVENT));
  },
  getAuthStatus: () => {
    const value = window.localStorage.getItem(`${storagePrefix}auth_status`);
    return value ? JSON.parse(value) : false;
  },
  clearAuthStatus: () => {
    window.localStorage.removeItem(`${storagePrefix}auth_status`);
    window.dispatchEvent(new Event(AUTH_STATUS_EVENT));
  },

  setEmail: (email) => {
    window.localStorage.setItem(`${storagePrefix}email`, JSON.stringify(email));
  },
  getEmail: () => {
    return JSON.parse(window.localStorage.getItem(`${storagePrefix}email`));
  },
  clearEmail: () => {
    window.localStorage.removeItem(`${storagePrefix}email`);
  },
};

export default storage;
